import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProjectObject } from '../brands.model';
import { LanguageService } from 'src/app/services/language.service';
import { RouterUrls } from '../router-urls';
import { BrandsService } from 'src/app/services/brands.service';

@Component({
  selector: 'app-impact-popup',
  templateUrl: './impact-popup.component.html',
  styleUrls: ['./impact-popup.component.scss']
})
export class ImpactPopupComponent implements OnInit {

  RouterUrls = RouterUrls;
  campaignId: number;
  campaignType: string;
  projects: ProjectObject[];
  isLoading = true;

  constructor(private dialogRef: MatDialogRef<ImpactPopupComponent>,
              private brandsService: BrandsService,
              private languageService: LanguageService,
              @Inject(MAT_DIALOG_DATA) data) {
                this.campaignId = data.campaignId;
                this.campaignType = data.campaignType;
                if (this.campaignType === 'matching_gift') {
                  this.brandsService.getMatchingGiftImpact(this.campaignId).subscribe(value => {
                    this.projects = value.projects;
                    this.isLoading = false;
                  });
                } else {
                  this.brandsService.getProgramImpact(this.campaignId).subscribe(value => {
                    this.projects = value.projects;
                    this.isLoading = false;
                  });
                }
  }

  ngOnInit() { }

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: [] });
  }

  get currentLanguage() {
    return this.languageService.getUserUsedLanguage();
  }
}
